/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ArrowRightLongIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 13 10", fill: "currentColor", width: size || '13', height: size || '10', ...props },
    React.createElement("path", { fill: "currentColor", d: "M11.862 5.856l.003-.003a.499.499 0 0 0 .001-.708l-4.013-4.01a.5.5 0 0 0-.707.707L10.304 5H.462c-.255 0-.462.224-.462.5s.207.5.462.5h9.84L7.147 9.145a.5.5 0 1 0 .706.709l3.987-3.976a.48.48 0 0 0 .022-.022z", fillRule: "evenodd" })));
ArrowRightLongIcon.displayName = 'ArrowRightLongIcon';
export default ArrowRightLongIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowRightLongIcon.js.map